module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-modal"
  }, [_c('sweet-modal', {
    ref: "bannerModal",
    staticClass: "bannerModal",
    attrs: {
      "title": _vm.type + ' Banner',
      "width": "80%"
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', [_c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "margin": "0"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "15px",
      "display": "flex",
      "width": "15%",
      "align-items": "center"
    }
  }, [_vm._v("Add Banner")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.hasError
    },
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "type": "file",
      "label": "Photo",
      "name": "photo",
      "data-vv-value-path": "input",
      "data-vv-name": "photo",
      "has-error": _vm.errors.has('photo'),
      "required": true,
      "id": "uploadInputFile"
    },
    on: {
      "change": _vm.changeFileHandle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form",
      "disabled": _vm.choosed
    },
    on: {
      "click": function($event) {
        _vm.onupload()
      }
    }
  }, [_vm._v("Upload")])]), _vm._v(" "), (_vm.suceessmessage) ? _c('h1', {
    staticStyle: {
      "font-size": "26px",
      "color": "green"
    }
  }, [_vm._v("✔")]) : _vm._e()]), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red",
      "margin-left": "15%"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.aspectRatioError) ? _c('h3', {
    staticStyle: {
      "color": "red",
      "margin-left": "15%"
    }
  }, [_vm._v(_vm._s(_vm.aspectRatioError))]) : _vm._e(), _vm._v(" "), (_vm.uploadingBar) ? _c('progress', {
    staticStyle: {
      "width": "50%",
      "margin-top": "20px"
    },
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.uploadPercentage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "padding-top": "1rem"
    }
  }, [(_vm.url) ? _c('div', {
    staticClass: "landscape",
    attrs: {
      "id": "preview"
    }
  }, [_c('h1', [_vm._v("Preview Banner")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.url,
      "id": "image",
      "alt": "Preview Banner Image"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bannerDetail.ImageUrl) ? _c('div', {
    staticClass: "landscape",
    attrs: {
      "id": "preview"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', [_vm._v("Saved Banner")]), _vm._v(" "), _c('v-popover', {
    staticStyle: {
      "float": "right",
      "padding-left": "17rem"
    },
    attrs: {
      "offset": "16",
      "placement": "top-center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Remove Banner")]), _vm._v(" "), _c('a', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "color": "black",
      "font-size": "large",
      "cursor": "pointer"
    }
  }, [_vm._v("❎")]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('p', [_vm._v("\n                    " + _vm._s(_vm.msg) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "padding-left": "5rem"
    }
  }, [_c('button', {
    staticClass: "btn btn--danger",
    on: {
      "click": function($event) {
        _vm.selectNoBanner('NORMAL')
      }
    }
  }, [_vm._v("yes")]), _vm._v("\n                     \n                  "), _c('button', {
    directives: [{
      name: "close-popover",
      rawName: "v-close-popover"
    }],
    staticClass: "btn btn--gray"
  }, [_vm._v("no")])])])], 2)], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.bannerDetail.ImageUrl,
      "alt": "Banner Image"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.bannerLink) ? _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', [_vm._v("Saved Banner Link")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.bannerLink,
      "target": "blank"
    }
  }, [_vm._v(_vm._s(_vm.bannerLink))]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "15px",
      "display": "flex",
      "width": "15%",
      "align-items": "center"
    }
  }, [_vm._v(_vm._s(_vm.type) + " Banner Link: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bannerDetail.Link),
      expression: "bannerDetail.Link"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "name": "Link"
    },
    domProps: {
      "value": (_vm.bannerDetail.Link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bannerDetail, "Link", $event.target.value)
      }
    }
  }), _vm._v("\n            \n          "), _c('p', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.linkError))])]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Banner Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bannerDetail.Type),
      expression: "bannerDetail.Type"
    }],
    staticStyle: {
      "height": "33px",
      "margin-left": "50px"
    },
    attrs: {
      "label": "Banner Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bannerDetail, "Type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "REGULAR"
    }
  }, [_vm._v("REGULAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US BANNER"
    }
  }, [_vm._v("US BANNER")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "save-banner"
    },
    on: {
      "click": function($event) {
        _vm.saveBanner()
      }
    }
  }, [_vm._v("SAVE")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4720596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/BannerManger/AddEditBanner.vue
// module id = 1863
// module chunks = 1